import * as React from 'react';
import {
    TabList,
    Tabs,
    Tab,
    TabPanels,
    TabPanel,
} from 'telstra-ui/components/tab/Tabs';
import { ListCasesInt } from '../cases-table/cases-table-int';
import { IActiveTabState } from '@telstra-connect/channel-care/state/cases-int'

interface IEnquiryListTabProps {
    activeTabState: IActiveTabState;
    unifiedTrackView?: boolean;
    setActiveTab?: (tabName: string) => void;
    onTryAgain?: () => void
    cidn?: string;

}

const EnquiryListTabView = (props: IEnquiryListTabProps) => {
    const tabSelected = (id) => {
        props.setActiveTab(id);
    };

    const tabNameProp = 'tbLink-CCD';
    const tabPanelName = 'tbContent-CCD';
    const unifiedTrackingTabClassName = '';
    const enquiryListTab = ['Order enquiry']
    const currentActiveTab = props.activeTabState.activeTab;

    return (
        <React.Fragment>
            <Tabs>
                {
                    <div className={unifiedTrackingTabClassName}>
                        <TabList>
                            {enquiryListTab.map((tab, i) => {
                                const active = tab === currentActiveTab;
                                return (
                                    <Tab
                                        name={tabNameProp}
                                        id={tab}
                                        key={i}
                                        active={active}
                                        panelName={tabPanelName}
                                        onClick={tabSelected}
                                    >
                                        {tab}
                                    </Tab>
                                );
                            })}
                        </TabList>
                    </div>
                }
                <TabPanels>
                    {enquiryListTab.map((tab, i) => {
                        const active = tab === currentActiveTab;

                        if (!active) {
                            return <React.Fragment />;
                        }
                        return (
                            <TabPanel name={tabPanelName}
                                id={tab}
                                key={i}
                                active={active}>
                                <ListCasesInt
                                    tabName={tab}
                                    unifiedTrackView={props.unifiedTrackView || false}
                                    activeTab={currentActiveTab}
                                    onTryAgain={props.onTryAgain}
                                    cidn={props.cidn}
                                />
                            </TabPanel>
                        );
                    })
                    }
                </TabPanels>
            </Tabs>
        </React.Fragment>
    );
};

export default EnquiryListTabView;
